// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    all_projects_label: '\"\"',
    Cancel: 'Zrušiť',
    completeActivityConfirm: 'Špecifikujte, ktorá činnosť je 100% kompletná. Chcete zmeniť jej status na \'kompletná\'? Stačte \'OK\' pre zmenu statusu, alebo \'Cancel\' inak.',
    confirmCompleteActivityParents: 'Dokončenie tejto čiastkovej činnosti sa neponechávajú otvorené, v jeho domovskom činnosti. Chceli by ste označiť rodičovskú činnosť dokončená? Všimnite si, že ak neexistujú žiadne ďalšie otvorené aktivít na projekte, budú označené dokončená tiež.',
};
